import { getDetailRoute } from '@features/rates/helpers/bookingRoutes.helper';
import { Dispatch, SetStateAction } from 'react';
import { useRouter } from 'shared-routing';
import { FormStep, StepType, StepTypeWithIndex } from '../../types';

export const usePreviousStep = (
  rateCode: string,
  currentStep: StepTypeWithIndex,
  setCurrentStep: Dispatch<SetStateAction<StepTypeWithIndex>>,
  allFormSteps: FormStep[]
) => {
  const router = useRouter();

  return () => {
    if (currentStep.type === 'rooms' && currentStep.step === 'guestDetailsStep') {
      return router.push({
        pathname: getDetailRoute(router.pathname),
        query: { id: rateCode, bookingStep: '' },
      });
    }

    return setCurrentStep((val) => {
      const prev = allFormSteps[val.index - 1];
      return prev
        ? { type: prev.type as StepType, index: val.index - 1, step: prev.step }
        : {
            type: 'rooms',
            index: 0,
            step: 'rooms',
          };
    });
  };
};
